export const profile: Record<string, string> = {
  'Access': 'Accès',
  'Account & preferences': 'Compte et préférences',
  'Account, language and session controls': 'Compte, langue et gestion de session',
  'Admin workspace': 'Espace administrateur',
  'Administrator': 'Administrateur',
  'Choose the language used across your admin workspace.':
    'Choisissez la langue utilisée dans votre espace administrateur.',
  'Choose a tour to revisit the parts of the portal you need.':
    'Choisissez une visite pour revoir les parties du portail dont vous avez besoin.',
  'Current language': 'Langue actuelle',
  'Email:': 'Adresse e-mail :',
  'France': 'France',
  'Guided tour': 'Visite guidée',
  'Language & region': 'Langue et région',
  'Language preference saved.': 'Préférence linguistique enregistrée.',
  'Manage how your workspace feels and review your signed-in account.':
    'Personnalisez votre espace et consultez les informations de votre compte connecté.',
  'New to the portal or need a refresher? Replay the guided walkthrough of the main features.':
    'Vous découvrez le portail ou souhaitez vous rafraîchir la mémoire ? Relancez la visite guidée des principales fonctionnalités.',
  'Profile': 'Profil',
  'Replay site tour': 'Relancer la visite guidée',
  'Replay tour': 'Relancer la visite',
  'Portal overview': 'Vue d’ensemble du portail',
  'Main tools and navigation': 'Outils principaux et navigation',
  'Schedule & Duty Board': 'Planning et tableau de service',
  'Creating, staffing and publishing rosters': 'Création, affectation et publication des plannings',
  'Saved on this device. Cloud sync is temporarily unavailable.':
    'Enregistré sur cet appareil. La synchronisation cloud est temporairement indisponible.',
  'Secure session active': 'Session sécurisée active',
  'Session': 'Session',
  'Settings': 'Paramètres',
  'Sign out securely when you have finished using this device.':
    'Déconnectez-vous en toute sécurité lorsque vous avez fini d’utiliser cet appareil.',
  'Signed in as': 'Connecté en tant que',
  'Take another look at the portal’s main tools and navigation.':
    'Redécouvrez les principaux outils et la navigation du portail.',
  'United Kingdom': 'Royaume-Uni',
  'Your choice is saved to your account and follows you across devices.':
    'Votre choix est enregistré dans votre compte et vous suit sur tous vos appareils.',
};
